import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NumberHelper } from '@core/helpers/number.helper';
import { CurrencyRateOperationEnum } from '@enums/CurrencyRateOperation';
import { CompanyCurrency } from '@interfaces/CompanyCurrency';
import { CurrencyService } from '@shared/services/currency.service';

@Component({
  selector: 'pop-currency-line',
  templateUrl: './currency-line.component.html',
  styleUrls: ['./currency-line.component.less']
})
export class CurrencyLineComponent implements OnInit {
  public calculation: string;
  public tooltip: string;
  public currencyOperationValues = Object.keys(CurrencyRateOperationEnum) as CurrencyRateOperationEnum[];
  public functionalCurrency: CompanyCurrency;
  public label: string;

  @Input() public currency: CompanyCurrency;
  @Output() public currencyChange: EventEmitter<CompanyCurrency> = new EventEmitter<CompanyCurrency>();

  @Input() public companyCurrencies: CompanyCurrency[];

  public ngOnInit(): void {
    this.functionalCurrency = this.companyCurrencies.find(c => c.isFunctional);
    this.label = `${this.functionalCurrency.currencyCode} --> ${this.currency.currencyCode}`;
    this.updateCalculation();
  }

  public updateRate(currency: CompanyCurrency, rate: string) {
    currency.rate = Number(rate);
    this.updated();
  }

  public updateOperation(currency: CompanyCurrency, value: string) {
    currency.operation = CurrencyRateOperationEnum[value];
    this.updated();
  }

  private updated() {
    this.currencyChange.next(this.currency);
    this.updateCalculation();
  }

  private updateCalculation() {
    if (this.currency.isFunctional) {
      this.currency.rate = 1;
      this.currency.operation = CurrencyRateOperationEnum.Multiplication;
      return;
    }

    const toFunctional = NumberHelper.format(
      CurrencyService.applyMultiplyer(1, this.currency.operation, this.currency.rate),
      NumberHelper.UpToTwoDecimals
    );

    const functionalCurencySymbol = this.functionalCurrency.currency.symbol;

    const oneDollarFunctional = `1${functionalCurencySymbol}`;
    const oneDollarConverted = `${toFunctional}${this.currency.currency.symbol}`;
    const part1 = `${oneDollarFunctional} = ${oneDollarConverted}`;

    const oneDollarInFunctional = NumberHelper.format(
      CurrencyService.removeMultiplyer(1, this.currency.operation, this.currency.rate),
      NumberHelper.UpToTwoDecimals
    );

    const oneDollarThisCurrency = `1${this.currency.currency.symbol}`;
    const oneDollarThisCurrencyConverted = `${oneDollarInFunctional}${functionalCurencySymbol}`;

    const part2 = `${oneDollarThisCurrency} = ${oneDollarThisCurrencyConverted}`;

    this.calculation = part1;
    this.tooltip = `${part1}\n${part2}`;
  }
}
